import { Core } from "@/core/Core";

export default {

  async getApiKey(context, {keyId}) {
    try {
      return await Core.request("GET", `/api/api_keys/${keyId}`);
    } catch (e) {
      return null;
    }
  },

  async saveApiKey(context, {data}) {
    try {
      return data.id
        ? await Core.request('PUT',  `/api/api_keys/${data.id}`, data)
        : await Core.request('POST', `/api/api_keys`, data);
    } catch (e) {
      return null;
    }
  },

  async deleteApiKey(context, {keyId}) {
    try {
      return await Core.request("DELETE", `/api/api_keys/${keyId}`);
    } catch (e) {
      return null;
    }
  }

}